import type { TCalculatorModeHandlerFactory } from '@src/types';

const createBasicModeHandlers: TCalculatorModeHandlerFactory = (actions) => ({
  handleNumber: (value?: string) => actions.appendDigit(value),
  handleDecimal: () => actions.appendDecimal(),
  handleOperator: (value?: string) => actions.applyOperator(value),
  handleEquals: () => actions.evaluateExpression(),
  handlePercent: () => actions.applyPercent(),
  handleClear: () => actions.clearAll(),
  handleBackspace: () => actions.backspace(),
});

export default createBasicModeHandlers;
